var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-field-input"},[(_vm.isBorderStyle)?[_c('el-tooltip',{attrs:{"content":_vm.value,"disabled":!_vm.value,"placement":"top"}},[_c('el-input',{attrs:{"value":_vm.value,"readonly":"","size":"mini"}})],1)]:[_c('span',{staticClass:"field-text"},[_vm._v(_vm._s(_vm.value || '-'))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }